import { ReactNode, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { DropdownIcon, TransparentButton, Typography } from '@libs/components';
type DropdownProps = {
  title: string;
  className?: string;
  children?: ReactNode;
};

export const Dropdown: React.FC<DropdownProps> = ({
  title,
  children,
  className,
}) => {
  const { colors } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={className}>
      <Header onClick={handleClick}>
        <Typography
          type="caption"
          fontFamily="primaryRegular"
          color={colors.text.secondary}
        >
          {title}
        </Typography>
        <DropdownWrapper isOpen={isOpen}>
          <DropdownIcon />
        </DropdownWrapper>
      </Header>
      {isOpen && <Body className="body">{children}</Body>}
    </div>
  );
};
type DropdrownProps = {
  isOpen?: boolean;
};
const Header = styled(TransparentButton)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.2rem 0.8rem;
`;
export const DropdownWrapper = styled.div<DropdrownProps>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
`;
export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;
